<template>
	<div>
		<div class="container-fluid font-size-11 font-size-sm-10 pb-3">
			<div class="col-12 background-blue-light text-blue rounded pt-2 pb-2 d-flex" v-if="info">
				<div class="font-size-12 m-auto"><i class="fas fa-exclamation-circle"></i></div>
				<div class="font-size-10 pl-2"> Silakan melengkapi  detail Alamat utama Mobile Counter Anda untuk data Pengiriman dan Verifikasi akun menjadi lebih lengkap. Pastikan Anda melengkapi data dengan benar.</div>
			</div>
			<form>
				<div class="row">
					<div class="col-md-6">
						<div class="row">
							<div class="col-md-12 pt-3">
								<div class="mb-1">Provinsi</div>
								<select :disabled="!info" class="form-control font-size-10 box-purple" v-model="paramsAddress.province" @change="selectProv(paramsAddress.province)">
									<option disabled value="">Pilih Provinsi</option>
									<option v-for="(value, index) in province" :key="index" :value="{ id: value.province_id, text: value.province }">{{value.province}}</option>
								</select>
								<div class="invalid-feedback d-block m-0" v-if="konfirmResponse.province_id">Provinsi {{ konfirmResponse.province_id }} </div>
								<div class="invalid-feedback d-block m-0" v-else-if="konfirmResponse.province_name">Provinsi {{ konfirmResponse.province_name }} </div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="mb-1 mt-3">Kota/Kabupaten</div>
								<select :disabled="!info" class="form-control font-size-10 box-purple" v-model="paramsAddress.city" @change="selectCity(paramsAddress.city)">
									<option disabled value="">Pilih Kota/Kabupaten</option>
									<option v-for="(value, index) in city" :key="index" :value="{id: value.city_id, text: value.city_name}">{{value.type}} {{value.city_name}}</option>
								</select>
								<div class="invalid-feedback d-block m-0" v-if="konfirmResponse.city_id">Kota {{ konfirmResponse.city_id }} </div>
								<div class="invalid-feedback d-block m-0" v-else-if="konfirmResponse.city_name">Kota {{ konfirmResponse.city_name }} </div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="mb-1 mt-3">Kecamatan</div>
								<select :disabled="!info" class="form-control font-size-10 box-purple" v-model="paramsAddress.subdistrict" @change="selectSubdistrict">
									<option disabled value="">Pilih Kecamatan</option>
									<option v-for="(value, index) in subdistrict" :key="index" :value="{id: value.subdistrict_id, text: value.subdistrict_name}">{{value.subdistrict_name}}</option>
								</select>
								<div class="invalid-feedback d-block m-0" v-if="konfirmResponse.subdistrict_id">Kecamatan {{ konfirmResponse.subdistrict_id }} </div>
								<div class="invalid-feedback d-block m-0" v-else-if="konfirmResponse.subdistrict_name">Kecamatan {{ konfirmResponse.subdistrict_name }} </div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="mb-1 mt-3">Alamat Lengkap</div>
								<textarea :disabled="!info" class="form-control font-size-10 textarea box-purple" rows="3" placeholder="Masukkan Alamat Lengkap" v-model="paramsAddress.address" @blur="updateMaps(paramsAddress.address)"></textarea>
								<div class="invalid-feedback d-block m-0" v-if="konfirmResponse.address">Alamat {{ konfirmResponse.address }} </div>
							</div>
						</div>
					</div>
					<div class="col-md-6 mt-4">
						<GmapMap
						:center="{
						lat: location.lat,
						lng: location.lng
					}"
					:zoom="16"
					:options="{
					zoomControl: false,
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: false,
					disableDefaultUi: true
				}"
				map-type-id="roadmap"
				style="width: 100%; height: 100%"
				>
				<GmapMarker
				ref="myMarker"
				:draggable="!disabled"
				:position="{
				lat: location.lat,
				lng: location.lng
			}"
			@dragend="updateCoordinates"
			/>
		</GmapMap>
	</div>
</div>
</form>
</div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Vue from 'vue'
import { googleApiKey } from '@/config';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapMarker from 'vue2-google-maps/src/components/marker';
Vue.component('GmapMarker', GmapMarker);
Vue.use(VueGoogleMaps, {
	installComponents: true,
	load: {
		key: googleApiKey,
		libraries: 'places',
	}
})

export default {
	data() {
		return {
			errors: {},
			provinsi:'',
			kota:'',
			kecamatan:'',
			alamat:'',
		};
	},
	props:{
		info: Boolean,
		disabled: Boolean,
	},
	computed: {
		...mapState('commonList', ['province', 'city', 'subdistrict', 'paramsAddress']),
		...mapState('maps', ['location']),
		...mapState('profileList', ['konfirmResponse']),
	},
	methods: {
		...mapActions('commonList', ['getProvince', 'getCity', 'getSubdistrict']),
		...mapActions('maps', ['postGeolocation', 'getMaps', 'getGeolocation']),

		selectProv(prov) {
			this.paramsAddress.city = {}
			this.paramsAddress.subdistrict = {}
			this.konfirmResponse.province_id = ''
			this.konfirmResponse.province_name = ''
			this.getCity({
				province_id: prov.id
			})
		},
		selectCity(city) {
			this.paramsAddress.subdistrict = {}
			this.konfirmResponse.city_id = ''
			this.konfirmResponse.city_name = ''
			this.getSubdistrict({
				city_id: city.id
			})
		},
		selectSubdistrict() {
			this.konfirmResponse.subdistrict_id = ''
			this.konfirmResponse.subdistrict_name = ''
			this.updateMaps()
		},
		updateCoordinates(location) {
			this.postGeolocation({
				lat: location.latLng.lat(),
				lng: location.latLng.lng()
			})
		},
		updateMaps(address = null) {
			this.getMaps((address ? address + ', ' : '') + this.paramsAddress.subdistrict.text + ', ' + this.paramsAddress.city.text + ', ' + this.paramsAddress.province.text)
		},
	},
	created() {
		this.getProvince()
		if (this.info) {
			this.getGeolocation();
		}
	}
};
</script>